// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scavBar{bottom:calc(var(--notification-height, 0px) + 2rem);transition:bottom .25s cubic-bezier(.4,0,.2,1)}@media (max-width:576px){.scavBar{bottom:calc(var(--notification-height, 0px) + 104px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
